module.exports = __webpack_public_path__ + "static/img/logo.57b683d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 1